export default __webpack_public_path__ + "static/media/sessions.de7205d3.svg";